export default "__VITE_ASSET__e59b6c16__"